import { ResumeAnalysis } from "lib/resume-scoring/resume-analysis/resume-analyse-types";
import { PersonalDetailsScoreAnalysis } from "lib/resume-scoring/types";
import { SectionCard } from "./SectionCard";
import { StatusItem } from "./StatusItem";

export const PersonalDetailsCard = ({
  score,
  maxScore,
  analysis,
  className = "",
}: {
  score: PersonalDetailsScoreAnalysis;
  maxScore: number;
  analysis: ResumeAnalysis["profile"];
  className?: string;
}) => {
  const criticalIssues = score.statementMistakeCount;
  const warningIssues = score.informationMistakeCount;
  const enhancements = score.linkMistakeCount;
  
  return (
    <SectionCard
      title="Personal"
      icon="personalDetails"
      score={score.totalScore}
      maxScore={maxScore}
      detailsLink="/score-check/personal"
      className={className}
    >
      <ul className="mb-3 mt-3 gap-y-3 overflow-auto">
        {criticalIssues !== 0 ? (
          <StatusItem
            icon="issue"
            title="Major Issues"
            subtitle="Impacting score"
            status="count"
            count={criticalIssues}
          />
        ) : (
          <StatusItem
            icon="noIssue"
            title="No issue found"
            subtitle="Good impact in score"
            status="success"
          />
        )}

        {warningIssues !== 0 ? (
          <StatusItem
            icon="contactNotFound"
            title="Missing Info"
            subtitle="Required information missing"
            status="count"
            count={warningIssues}
          />
        ) : (
          <StatusItem
            icon="contactNotFound"
            title="Information obtained"
            subtitle="No info is missing"
            status="success"
          />
        )}

        {enhancements ? (
          <StatusItem
            icon="linkMissing"
            title="Links Missing"
            subtitle="Suggested to add links"
            status="count"
            count={enhancements}
          />
        ) : (
          <StatusItem
            icon="linkMissing"
            title="Links found"
            subtitle="Experience links detected"
            status="success"
          />
        )}
      </ul>
    </SectionCard>
  );
};
